import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import QualificationDialog from './QualificationDialog';
import PhotoSlider from './PhotoSlider';
import { ABOUT_PHOTOS } from '../data/aboutPhotos';

// A képesítések és az alapértékek blokk a főoldal aljára került
// (components/CredentialsValuesSection.jsx) — a Rólam szekció így
// a személyes történetre fókuszál.

const AboutSection = ({ onBookClick }) => {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Image — mobilon a szöveg fölött, asztalin bal oldalon */}
          <div className="relative">
            <div className="relative h-[420px] sm:h-[520px] md:h-[600px] rounded-lg overflow-hidden shadow-2xl">
              <PhotoSlider
                photos={ABOUT_PHOTOS}
                testId="about-photo-slider"
                className="w-full h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent pointer-events-none"></div>
            </div>
            <div
              data-testid="about-experience-badge"
              className="absolute -bottom-5 right-4 md:-bottom-6 md:-right-6 bg-yellow-600 text-gray-900 px-6 py-5 rounded-lg shadow-xl max-w-[220px]"
            >
              <div className="text-3xl md:text-4xl font-bold mb-0.5 leading-none" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                14 ÉV
              </div>
              <div className="text-xs md:text-sm font-semibold tracking-wide break-words">
                edzéstapasztalat
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="pt-8 md:pt-0">
            <div className="inline-block mb-5 px-4 py-2 bg-yellow-100 rounded-full">
              <span className="text-yellow-700 font-semibold text-sm tracking-wider">RÓLAM</span>
            </div>

            <h2
              data-testid="about-heading"
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Szia, <span className="text-yellow-600">Orosz Gábor</span> vagyok
            </h2>

            <div className="space-y-4 text-base md:text-lg text-gray-700 leading-relaxed">
              <p>
                Már <span className="font-semibold text-gray-900">14 éve edzek</span>. Az elején én is csak le akartam
                fogyni és erősödni egy kicsit, aztán annyira megszerettem, hogy elkezdtem komolyabban utánajárni,
                hogyan működik ez az egész valójában. Műszakos munkarend mellett, apránként, magamtól tanultam meg
                mindent, így jutottam el a mostani formámig.
              </p>
              <p>
                Közben rengeteg fitneszes tartalmat láttam, és azt tapasztaltam, hogy ezekben nagyon sok a félrevezető
                tanács: csodadiéták, gyors megoldások, olyan ígéretek, amik inkább eladni akarnak, mint segíteni. Azt
                hirdetik, hogy minden megoldható varázsütésre, pedig a jó forma nem egy hónap alatt jön, hanem
                szokásokból épül fel, amiket aztán egész életedben magaddal viszel.
              </p>
              <p>
                Ezért végeztem el a sportedzői képzést: szeretnék segíteni azoknak, akik ott tartanak, ahol én az
                elején, hogy ne kelljen éveket elvesztegetniük próbálkozással, hanem rögtön szilárd alapokra
                építhessék a fejlődésüket.
              </p>
              <p>
                Tudom, milyen fáradtan munka előtt vagy után nekiállni az edzésnek, ezért nem adok olyan tervet, ami
                csak papíron működik. Olyat kapsz, ami belefér az életedbe, amit hónapok múlva is tudsz tartani, és
                ami segít, hogy megszeresd magát a mozgást.
              </p>
              <p>
                Nálam <span className="font-semibold text-gray-900">nem kell fittnek lenned</span>, és semmilyen
                előképzettség sem kell ahhoz, hogy elkezdjük a közös munkát. Ígérem, kínosan sem fogod érezni magad a
                teremben. Mindent megbeszélünk, elmagyarázom, mit miért csinálunk, mert ha érted, sokkal könnyebb
                végigcsinálni.
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-2 text-base">
              <QualificationDialog
                label="Okleveles testépítés-fitnesz sportedző"
                testId="about-qualification-trigger"
              />
            </div>

            <Button
              data-testid="about-book-btn"
              onClick={onBookClick}
              size="lg"
              className="mt-8 w-full sm:w-auto bg-yellow-600 hover:bg-yellow-500 text-gray-900 font-bold py-5 h-auto whitespace-normal leading-snug"
            >
              Ingyenes konzultációt kérek
              <ArrowRight className="ml-2 shrink-0" size={18} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
